import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store/index";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "context/react-lib/firebase-auth/AuthProvider";
import { colors } from "colors";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { PostHogProvider } from "posthog-js/react";

import LogRocket from "logrocket";
import { Toaster } from "react-hot-toast";
LogRocket.init("moz8y3/cheap-gpt");

const options = {
  api_host: "https://eu.i.posthog.com",
};

const theme = createTheme({
  palette: {
    primary: {
      main: colors.black,
    },
    secondary: {
      main: colors.pink,
    },
    red: {
      main: "#EA3546",
    },
    green: {
      main: colors.green,
    },
    pink: {
      main: colors.pink,
      contrastText: colors.white,
    },
    black: {
      main: colors.black,
      contrastText: colors.white,
    },
    white: {
      main: colors.white,
      contrastText: colors.black,
    },
    wwhite: {
      main: colors.white,
      contrastText: colors.white,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <PostHogProvider
    apiKey={"phc_2pL3XMFJF5bgVhVZory4V29sNaEeYw3pCO0YKPLuhhq"}
    options={options}
  >
    <BrowserRouter>
      <Provider store={store}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <AuthProvider>
            <Toaster />
            <App />
          </AuthProvider>
        </LocalizationProvider>
      </Provider>
    </BrowserRouter>
  </PostHogProvider>
);

reportWebVitals();

if ("serviceWorker" in navigator) {
  window.addEventListener("load", function () {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then(() => {
        console.log("Service Worker registered successfully.");
        // detect controller change and refresh the page
        var refreshing = false;
        navigator.serviceWorker.addEventListener(
          "controllerchange",
          function () {
            console.log("Service worked updated");
            if (!refreshing) {
              refreshing = true;
              window.location.reload();
            }
          }
        );
      })
      .catch((error) =>
        console.log("Service Worker registration failed:", error)
      );
  });
}
